import { Helmet } from "react-helmet";

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url,
  type = "website",
  schemaData 
}) => {
  const siteUrl = "https://www.pimot.com.do";
  const defaultImage = "https://customer-assets.emergentagent.com/job_f225f10b-d8b4-4ffa-b240-0898e7a29d8d/artifacts/d1672wh9_LogoBlancoSinfondo-%20website.png";
  
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image || defaultImage;

  return (
    <Helmet>
      {/* Título y Meta Tags Básicos */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Pimot Construcciones" />
      <meta property="og:locale" content="es_DO" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      
      {/* Datos Adicionales */}
      <meta name="author" content="Pimot Construcciones" />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="DO" />
      <meta name="geo.placename" content="República Dominicana" />
      
      {/* Schema.org JSON-LD */}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;